import { Rule, FormInstance } from "antd/es/form";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { ColProps } from "antd/lib/grid/col";
import { FormLabelAlign } from "antd/lib/form/interface";
import { IYhBox } from "../YhBox/Types";
import { NamePath, Store } from "rc-field-form/es/interface";
import { MutableRefObject, Ref } from "react";

export enum FormItemTypeEnum {
    Input,
    InputNumber,
    Select,
    Datepicker,
    Switch,
    JsonView,
    TreeSelect,
    FileImage,
}

export interface ITreeData {
    value: string,
    title: string,
    children: ISelectOption[]
}

export interface ISelectOption {
    label: string,
    value: string
    [key: string]: any
}
export interface Options {
    key: number | string,
    label: string,
    value: string | number,
    [key: string]: any
}
export interface IFormItem {
    type: FormItemTypeEnum;
    fieldLabel: string;
    fieldName: string;
    placeholder?: string;
    ds?: ITreeData[] | ISelectOption[];
    labelCol?: { span?: number, offset?: number },
    hidden?: boolean;
    allowClear?: boolean;
    size?: SizeType;
    disable?: boolean;
    multiple?: boolean;
    labelInValue?: boolean,
    rules?: Rule[],
    span?: number,
    checkedChildren?: string,
    unCheckedChildren?: string,
    valuePropName?: string,
    options?: Options[],
    md5List?: string[],
    [key: string]: any
}

export interface IYhFormItemsBox extends IYhBox {
    items: IFormItem[],
    justify?: "start" | "end" | "center" | "space-around" | "space-between",
    IclassName?: string,
    disabled?: boolean
}

export interface IYhFormBox<IValues = any> {
    colon?: boolean;
    name?: string;
    labelCol?: ColProps;
    labelAlign?: FormLabelAlign;
    onChange?: (changedValues: { [key: string]: any }, values?: IValues) => void;
    onFinish?: (values: IValues) => void
    onReset?: () => {};
    formValues?: {};
    disabled?: boolean;
    boxs: IYhFormItemsBox[];
}
export interface IYhFormRef<T = any> {
    validateFields: () => Promise<T>,
    getFieldsValue: () => any,
    setFieldsValue: (changedValues: { [key: string]: any }) => void;
    resetFields: (fields?: NamePath[]) => void,
    inst: () => FormInstance,
}
export interface IYhForm<T = any> {
    formRef?: MutableRefObject<IYhFormRef<T> | undefined>,
    colon?: boolean;
    name?: string;
    labelCol?: ColProps;
    labelAlign?: FormLabelAlign;
    onChange?: (changedValues: { [key: string]: any }, values?: T) => void;
    onFinish?: (values: T) => void
    onReset?: () => {};
    formValues?: any;
    disabled?: boolean;
    items: IFormItem[];
}